import { render, staticRenderFns } from "./AcceptDialog.vue?vue&type=template&id=4dd5a6ab&scoped=true"
import script from "./AcceptDialog.vue?vue&type=script&lang=js"
export * from "./AcceptDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd5a6ab",
  null
  
)

export default component.exports